import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FallbackComponent } from './fallback.component';
import { AuthGuardWithForcedLogin } from './core/auth/auth-guard-login.service';
import { RoleGuard } from './core/auth/role-guard.service';
import { LogoutListenerComponent } from './logout-listener.component';
import { UnsubscribePageComponent } from './pages/unsubscribe/unsubscribe.component';
import { LpTelegramPageComponent } from './pages/lp-telegram/lp-telegram.component';
import { WelcomeRelateduserComponent } from './pages/welcome-relateduser/welcome-relateduser.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { TalentOnboardInvitationComponent } from './pages/talent-onboard-invitation/talent-onboard-invitation.component';
import { HmOnboardInvitationComponent } from './pages/hm-onboard-invitation/hm-onboard-invitation.component';
import { EmailPolicyBreakComponent } from './pages/email-policy-break/email-policy-break.component';
import { AccountDisabledComponent } from './pages/account-disabled/account-disabled.component';
import { AuthorizedScopeComponent } from './pages/authorized-scope/authorized-scope.component';
import { invitationGuard } from './core/auth/invitation.guard';
import { InvitationExpiredComponent } from './pages/invitation-expired/invitation-expired.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'talent',
    pathMatch: 'full'
  },
  {
    path: 'skills-validation',
    redirectTo: 'talent/talent/skills-validation',
    pathMatch: 'full'
  },
  {
    path: 'talent',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuardWithForcedLogin, RoleGuard],
    data: { roles: ['talent'] }
  },
  {
    path: 'hm',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuardWithForcedLogin, RoleGuard],
    data: { roles: ['hm', 'admin'] }
  },
  {
    path: '', 
    children: [], 
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./pages/onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuardWithForcedLogin]
  },
  {
    path: 'create-position',
    loadChildren: () => import('./pages/position-create/position-create.module').then(m => m.PositionCreateModule),
    canActivate: [AuthGuardWithForcedLogin, RoleGuard],
    canActivateChild: [RoleGuard],
    data: { roles: ['hm'] }
  },
  {
    path: 'page',
    loadChildren: () => import('./pages/public-pages/public-pages.module').then(m => m.PublicPagesModule),
  },
  {
    path: 'sl',
    loadChildren: () => import('./pages/shared-links/shared-links.module').then(m => m.SharedLinksModule),
  },
  {
    path: 'guest',
    loadChildren: () => import('./pages/guest-mode/guest-mode.module').then(m => m.GuesModeModule),
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuardWithForcedLogin, RoleGuard],
    canActivateChild: [RoleGuard],
    data: { roles: ['admin'] }
  },
  {
    path: 'job-boards/:board',
    redirectTo: 'dashboard/job-boards/:board',
    pathMatch: 'full'
  },
  {
    path: 'logout-listener',
    component: LogoutListenerComponent
  },
  {
    path: 'unsubscribe',
    component: UnsubscribePageComponent
  },
  {
    path: 'telegram',
    component: LpTelegramPageComponent
  },
  {
    path: 'onboard/:unique-user-id',
    component: WelcomeRelateduserComponent
  },
  {
    path: 'talent-onboard',
    component: TalentOnboardInvitationComponent
  },
  {
    path: 'hm-onboard',
    component: HmOnboardInvitationComponent,
    canActivate: [invitationGuard]
  },
  {
    path: 'invitation-expired',
    component: InvitationExpiredComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'email-policy-break',
    component: EmailPolicyBreakComponent
  },
  {
    path: 'account-disabled',
    component: AccountDisabledComponent
  },
  {
    path: 'authorized-scope',
    component: AuthorizedScopeComponent
  },
  { path: "**", redirectTo: "" },
  { path: '**', component: FallbackComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
